import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EventClass;
function Event() {
  if (EventClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Event');
    EventClass = $;
  }
  return EventClass;
}
var OperationResponseClass;
function OperationResponse() {
  if (OperationResponseClass === VOID) {
    class $ {
      constructor(id, payload) {
        this.l6b_1 = id;
        this.m6b_1 = payload;
      }
      k31() {
        return this.l6b_1;
      }
    }
    initMetadataForClass($, 'OperationResponse', VOID, VOID, [Event()]);
    OperationResponseClass = $;
  }
  return OperationResponseClass;
}
var OperationErrorClass;
function OperationError() {
  if (OperationErrorClass === VOID) {
    class $ {
      constructor(id, payload) {
        this.j6b_1 = id;
        this.k6b_1 = payload;
      }
      k31() {
        return this.j6b_1;
      }
    }
    initMetadataForClass($, 'OperationError', VOID, VOID, [Event()]);
    OperationErrorClass = $;
  }
  return OperationErrorClass;
}
var OperationCompleteClass;
function OperationComplete() {
  if (OperationCompleteClass === VOID) {
    class $ {
      constructor(id) {
        this.i6c_1 = id;
      }
      k31() {
        return this.i6c_1;
      }
    }
    initMetadataForClass($, 'OperationComplete', VOID, VOID, [Event()]);
    OperationCompleteClass = $;
  }
  return OperationCompleteClass;
}
var GeneralErrorClass;
function GeneralError() {
  if (GeneralErrorClass === VOID) {
    class $ {
      constructor(payload) {
        this.b6b_1 = payload;
        this.c6b_1 = null;
      }
      k31() {
        return this.c6b_1;
      }
    }
    initMetadataForClass($, 'GeneralError', VOID, VOID, [Event()]);
    GeneralErrorClass = $;
  }
  return GeneralErrorClass;
}
var NetworkErrorClass;
function NetworkError() {
  if (NetworkErrorClass === VOID) {
    class $ {
      constructor(cause) {
        this.h6b_1 = cause;
        this.i6b_1 = null;
      }
      k31() {
        return this.i6b_1;
      }
    }
    initMetadataForClass($, 'NetworkError', VOID, VOID, [Event()]);
    NetworkErrorClass = $;
  }
  return NetworkErrorClass;
}
var StartOperationClass;
function StartOperation() {
  if (StartOperationClass === VOID) {
    class $ {
      constructor(request) {
        this.z6b_1 = request;
      }
    }
    initMetadataForClass($, 'StartOperation', VOID, VOID, [Command()]);
    StartOperationClass = $;
  }
  return StartOperationClass;
}
var RestartConnectionClass;
function RestartConnection() {
  if (RestartConnectionClass === VOID) {
    class $ {}
    initMetadataForObject($, 'RestartConnection', VOID, VOID, [Command()]);
    RestartConnectionClass = $;
  }
  return RestartConnectionClass;
}
var RestartConnection_instance;
function RestartConnection_getInstance() {
  return RestartConnection_instance;
}
var ConnectionReEstablishedClass;
function ConnectionReEstablished() {
  if (ConnectionReEstablishedClass === VOID) {
    class $ {
      constructor() {
        this.j6c_1 = null;
      }
      k31() {
        return this.j6c_1;
      }
    }
    initMetadataForClass($, 'ConnectionReEstablished', ConnectionReEstablished, VOID, [Event()]);
    ConnectionReEstablishedClass = $;
  }
  return ConnectionReEstablishedClass;
}
var CommandClass;
function Command() {
  if (CommandClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Command');
    CommandClass = $;
  }
  return CommandClass;
}
var DisposeClass;
function Dispose() {
  if (DisposeClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Dispose', VOID, VOID, [Command()]);
    DisposeClass = $;
  }
  return DisposeClass;
}
var Dispose_instance;
function Dispose_getInstance() {
  return Dispose_instance;
}
var StopOperationClass;
function StopOperation() {
  if (StopOperationClass === VOID) {
    class $ {
      constructor(request) {
        this.x6b_1 = request;
      }
    }
    initMetadataForClass($, 'StopOperation', VOID, VOID, [Command()]);
    StopOperationClass = $;
  }
  return StopOperationClass;
}
//region block: init
RestartConnection_instance = new (RestartConnection())();
Dispose_instance = new (Dispose())();
//endregion
//region block: exports
export {
  Command as Command2ao3eytvqoynn,
  ConnectionReEstablished as ConnectionReEstablishedspo1kq7uvs59,
  Dispose as Dispose3n637sa8gbmf1,
  Event as Event2qcujbxqrid4f,
  GeneralError as GeneralError1q7afgn844yvi,
  NetworkError as NetworkErrorotwtrw4n54or,
  OperationComplete as OperationComplete35pb9wj3i5rr0,
  OperationError as OperationError2sah6hjojh8as,
  OperationResponse as OperationResponseq42n5mfh87yx,
  RestartConnection as RestartConnection3ucejekzrnll6,
  StartOperation as StartOperation372o3p2p9vxt5,
  StopOperation as StopOperation41dlmx7s82zc,
  Dispose_instance as Dispose_instance2o1vl3dhvm8a9,
  RestartConnection_instance as RestartConnection_instancely4s5aq31fta,
};
//endregion

//# sourceMappingURL=WsMessage.mjs.map
